import Account from "../models/account";
import httpService from "./httpService";
import Location from "../models/location";

const apiEndpoint = "/accounts";

const getAccounts = (idSubscription: number) => {
  return httpService.get<Account[]>(
    `${apiEndpoint}/getAccounts?idSubscription=${idSubscription}`
  );
};

const getAccountById = (idSubscription: number, idAccount: number) => {
  return httpService.get<Account>(
    `${apiEndpoint}/getAccountById?idSubscription=${idSubscription}&idAccount=${idAccount}`
  );
};

const createAccount = (idSubscription: number, account: Account) => {
  return httpService.post<Account>(
    `${apiEndpoint}/createAccount?idSubscription=${idSubscription}`,
    account
  );
};

const updateAccount = (idSubscription: number, account: Account) => {
  return httpService.post<Account>(
    `${apiEndpoint}/updateAccount?idSubscription=${idSubscription}`,
    account
  );
};

const deleteAccount = (idSubscription: number, idAccount: number) => {
  return httpService.delete<Account>(
    `${apiEndpoint}/deleteAccount?idSubscription=${idSubscription}&idAccount=${idAccount}`
  );
};

const getLocations = (idSubscription: number) => {
  return httpService.get<Location[]>(
    `${apiEndpoint}/getLocations?idSubscription=${idSubscription}`
  );
};

const getLocationById = (idSubscription: number, idLocation: number) => {
  return httpService.get<Location>(
    `${apiEndpoint}/getLocationById?idSubscription=${idSubscription}&idLocation=${idLocation}`
  );
};

const createLocation = (idSubscription: number, location: Location) => {
  return httpService.post<Location>(
    `${apiEndpoint}/createLocation?idSubscription=${idSubscription}`,
    location
  );
};

const updateLocation = (idSubscription: number, location: Location) => {
  return httpService.post<Location>(
    `${apiEndpoint}/updateLocation?idSubscription=${idSubscription}`,
    location
  );
};

const deleteLocation = (idSubscription: number, idLocation: number) => {
  return httpService.delete<Location>(
    `${apiEndpoint}/deleteLocation?idSubscription=${idSubscription}&idLocation=${idLocation}`
  );
};

const accountService = {
  getAccounts,
  getAccountById,
  createAccount,
  updateAccount,
  deleteAccount,
  getLocations,
  getLocationById,
  createLocation,
  updateLocation,
  deleteLocation,
};

export default accountService;
